import { NavLink } from "react-router";
import { useGlobalContext } from "app/store/GlobalContext";
import { SubMenuItemType } from "models/header/menuItems";
import Badge from "components/badge/Badge";

import "./SecondaryMenu.scss";

type Props = {
  menuItems: SubMenuItemType[];
};

export default function SecondaryMenu({ menuItems }: Props) {
  const { handleNavigation } = useGlobalContext();

  return (
    <div className="secondaryMenu">
      <div className="secondaryMenuInner">
        <nav>
          <ul>
            {menuItems.map((item, index) => (
              <li key={index} className={item.disabled ? "disabled" : ""}>
                <NavLink
                  to={item.href}
                  onClick={(e) => {
                    if (item.disabled) {
                      e.preventDefault();
                      return;
                    }
                    handleNavigation({
                      url: item.href,
                      eventTitle: item.title,
                      e: e,
                    });
                  }}
                  title={item.text}
                >
                  {item.title}
                  {typeof item.count === "number" && item.count > 0 && (
                    <Badge className="badge" count={item.count} hideCount />
                  )}
                  {item.notice && <Badge className="badge" notice={item.notice} />}
                </NavLink>
              </li>
            ))}
          </ul>

        </nav>
      </div>
    </div>
  );
}
